import { createSlice } from '@reduxjs/toolkit';
import { batch } from 'react-redux'
import MemberServices from '../services/MemberService';
import LiveCenterServices from '../services/LiveCenterServices';
import {
  SPORT_TABS, VirtualSports, COMPACT_SPORT_MENU, SportItemMap, BET_TYPE_HORSE_RACING,
  ESportItemMap, MARKET_TABS, DIRECT_PERIODS_FOLDER_SUM, BetTypeSummaryMap,
  SportGroup, BetTypeGroup, Market, EsportMarket, Mode, OUTRIGHT_TYPE, BUTTON_SELECTION, 
  BETSLIP_TABS, URL_VS_SPORTS_CODE, MESSAGES_LEFT_MENU_WS, E_SPORT_ID, EMPTY_VALUE
} from '../common/Foundation';
import {
  changeEsportGame, enableReUpdateNoLiveMenu, disableReUpdateNoLiveMenu,
  changeSportId, changeVirtualSportId, changeMarketTab, changeMarketId, changeHorseRacingMarketTab, changeHorseRacingMarketId,
  resetMarketTab, resetMarketId, changeSportTab, resetEsportGame, changeButton, updateSelectEsportLiveTab, setIsSelectFromDropdown, updateFirstSportId
} from './SidebarSelectedDataSlice';
import Constants from '../common/Constants';
import CommonUtil from '../common/CommonUtil';
import { resetLiveCenter, resetLiveTV, resetSearchData, SportsSlice, updateChangedOptions } from './SportsSlice';
import { LayoutTemplateSlice } from './LayoutTemplateSlice';
import { changeVSBetslipTab } from './VSBetslipSlice';
import _ from 'lodash';

const EMPTY_OBJECT = {}
export const  initialState = {
  loading: false,
  // init data from template
  sportTabs: [],
  marketTabs: [],
  esportMarketTabs: [],
  selectionButtons: [],

  // store data from service
  sports: [],
  esports: [],
  virtualSports: [],

  teasers: {},
  
  // data using for render ui
  liveMenu: [],
  liveEsportsMenu: [],
  isShowLiveTv: false,
  noLiveMenu: [],
  noLiveEsportsMenu: [],
  markets: [],
  specialLeagues: [],
  menuDropdownData: {
    liveMenu: [],
    todayMenu: [],
    earlyMenu: [],
    liveEsportsMenu: [],
    todayEsportsMenu: [],
    earlyEsportsMenu: []
  }
}

export const SidebarHandlerSlice = createSlice({
  name: 'SidebarHandlerSlice',
  initialState,
  reducers: {
    updateLoading: state => {
      state.loading = true
    },
    getSportsMenuSuccess: (state, {payload}) => {
      state.loading = false
      state.sports = payload.sports
      state.esports = payload.esport
      state.specialLeagues = payload.specialLeagues
      state.teasers = payload.groups.teasers['m'].reduce((teasers, sport) => {
        teasers[sport.i] = sport
        return teasers
      }, {})
    },
    
    getVirtualSportsSuccess: (state, {payload}) => {
      state.virtualSports = payload
    },
    updateLiveMenu: (state, {payload}) => {
      state.liveMenu = payload
    },
    updateLiveEsportsMenu: (state, {payload}) => {
      state.liveEsportsMenu = payload
    },
    updateShowLiveTv: (state, {payload}) => {
      state.isShowLiveTv = payload
    },
    updateNoLiveMenu: (state, {payload}) => {
      state.noLiveMenu = payload
    },
    updateNoLiveEsportsMenu: (state, {payload}) => {
      state.noLiveEsportsMenu = payload
    },
    updateMenuDropdownData: (state, {payload}) => {
      state.menuDropdownData = payload
    },
    updateMarkets: (state, {payload}) => {
      state.markets = payload
    },
    initSportTabs: (state, {payload}) => {
      state.sportTabs = payload
    },
    initMarketTabs: (state, {payload}) => {
      state.marketTabs = payload
    },
    initSelectionButtons: (state, {payload}) => {
      state.selectionButtons = payload
    },
    initEsportMarketTabs: (state, {payload}) => {
      state.esportMarketTabs = payload
    },
    updateLeftMenu: (state, { payload }) => {
      state[payload.key] = payload.data
    },
  }
})

export const {
  updateLoading,
  getSportsMenuSuccess,
  getSportsMenuFailure,
  getVirtualSportsSuccess,
  updateLiveMenu,
  updateLiveEsportsMenu,
  updateShowLiveTv,
  updateNoLiveMenu,
  updateNoLiveEsportsMenu,
  updateMenuDropdownData,
  updateMarkets,
  initSportTabs,
  initMarketTabs,
  initEsportMarketTabs,
  initSelectionButtons,
  updateLeftMenu
} = SidebarHandlerSlice.actions

export const sidebarHandlerSelector = state => state.SidebarHandlerSlice
export default SidebarHandlerSlice.reducer


export const fetchSportsMenu = () => {
  return async (dispatch, getState) => {
    if (getState().SidebarHandlerSlice.sports.length === 0) {
      // show loading in the first time loading data or error service
      dispatch(updateLoading())
    }
    try {
      const country = 'US', v = '';
      const response = await MemberServices.getAsiaSportsMarkets(country, v).then(res => {
        return res.data;
      }).catch(e => {
        dispatch(getSportsMenuFailure());
      });
      dispatch(onGetSportMarket(response))
    } catch (error) {
      dispatch(updateLoading())
    }
  }
}

const onGetSportMarket = (response) => {
  return (dispatch, getState) => {
    batch(() => {
      // Check the Live TV has events or not.
      dispatch(updateHasLiveEvent(response.numOfLiveTVEvents));

      // Sort sports base on user/agent setting
      const mode = getState().SportsSlice.options.mode;
      const sortedSports = CommonUtil.sortSportsPriority(response.sports, getState().SportsSlice.options.sportsSorting)
      response.sports = sortedSports;

      if (!getState().SidebarSelectedDataSlice.selectedSportId && mode !== Mode.SEARCH) {
        // choose default sport
        let sportName = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1).toLowerCase();
        const sportId = sortedSports.reduce((sportId, sport) => {
          if (CommonUtil.formatSportNameOnUrl(sport[1][SportItemMap.name]) === sportName) {
            sportId = sport[SportItemMap.id]
          }
          return sportId
        }, sortedSports[0][0])
        dispatch(changeSportId(sportId));
        dispatch(updateFirstSportId(sortedSports[0][0]));
      }

      if (!getState().SidebarSelectedDataSlice.selectedButton) {
        // choose default selection button is 'All Events'
        dispatch(changeButton(BUTTON_SELECTION.ALL_EVENTS))
      }
      dispatch(getSportsMenuSuccess(response))
      // get menu for sport and esport tab
      if (getState().SidebarSelectedDataSlice.selectedSportTab !== SPORT_TABS.VIRTUAL_SPORTS) {
        dispatch(getMenuBySportTab())
      }
    })
  }
}

export const fetchEventLC = () => {
  return async (dispatch, getState) => {
    try {
        const response = await LiveCenterServices.getAllEventLivenCenter().then(res => {
          return res.data;
        }).catch(e => {

        });
        const isLiveCenterEvent = (response && response.events && response.events.length > 0) ? true : false;
        dispatch(LayoutTemplateSlice.actions.updateHasCenterEvent(isLiveCenterEvent));      
    } catch (error) {}
  }
}

export const fetchVirtualSportMenu = () => {
  return async (dispatch, getState) => {
    try {
        const response =  await MemberServices.getVirtualSports().then(res => {
          return res.data;
        }).catch(e => {
        
        });
        dispatch(getVirtualSportsSuccess(response))
      // get menu for virtual sport
      if (getState().SidebarSelectedDataSlice.selectedSportTab === SPORT_TABS.VIRTUAL_SPORTS) {
        dispatch(getMenuBySportTab())
      }
    } catch (error) {}
  }
}

export const getMenuBySportTab = (marketTab) => {
  let liveMenu = [], noLiveMenu = [], liveEsportsMenu = [], noLiveEsportsMenu = []
  return (dispatch, getState) => {
      const {
        sports,
        esports,
        virtualSports
      } = getState().SidebarHandlerSlice

      const {
        mode
      } = getState().SportsSlice.options;

      if (mode === Mode.SEARCH) {
        return;
      }

      if (sports.length > 0 || (virtualSports && Object.keys(virtualSports).length > 0 )) {
        const selectedSportTab = getState().SidebarSelectedDataSlice.selectedSportTab
        const selectedSportId = getState().SidebarSelectedDataSlice.selectedSportId
        const selectedMarketTab = marketTab ? marketTab : getState().SidebarSelectedDataSlice.selectedMarketTab
        const dropdownMenuData  = getDropdownMenuData(sports, esports)
        let isChangeEsportGame = false
        switch (selectedSportTab) {
          case SPORT_TABS.ESPORTS:
            liveMenu = filterLiveMenu(esports, ESportItemMap)
            noLiveMenu = filterEsportNoLiveMenu(esports)
            isChangeEsportGame = true
            break
          case SPORT_TABS.VIRTUAL_SPORTS:
            noLiveMenu = generateVirtualSportsMenu(virtualSports)
            break
          default:
            liveMenu = filterLiveMenu(sports, SportItemMap)
            noLiveMenu = filterNoLiveMenu(sports, esports, selectedSportId)

            if (window.env.leftMenuRemoveEsportsTab) {
              liveEsportsMenu = filterLiveMenu(esports, ESportItemMap)
              noLiveEsportsMenu = filterEsportNoLiveMenu(esports)
            }

            if (selectedSportId === Constants.ESPORT_ID) {
              isChangeEsportGame = true
            }
            break
        }
        if (isChangeEsportGame)  {
          if (!getState().SidebarSelectedDataSlice.selectedEsportGame) {
            // 'allGames' is default when switch between 'Sports' tab and 'Esports' tab
            dispatch(changeEsportGame(Constants.ESPORT_ALL_GAMES_CODE))
          }
          isChangeEsportGame = false
        }
        batch(() => {
          dispatch(updateLiveMenu(liveMenu))
          dispatch(updateNoLiveMenu(noLiveMenu))
          dispatch(updateMenuDropdownData(dropdownMenuData))
          dispatch(updateLiveEsportsMenu(liveEsportsMenu))
          dispatch(updateNoLiveEsportsMenu(noLiveEsportsMenu))
          if(selectedSportId === Constants.HORSE_RACING_ID && selectedSportTab === SPORT_TABS.SPORTS) {
            dispatch(getHorseRacingMarkets(getState().SidebarSelectedDataSlice.selectedHorseRacingMarketTab))
          } else {
            dispatch(getMarkets(selectedMarketTab))
          }
        })
        
      }
  }
}

const getDropdownMenuData = (sports, esports) => {
  const liveMenu = filterLiveMenu(sports, SportItemMap)
  const { todayMenu, earlyMenu } = filterNoLiveDropdownMenu(sports, esports, liveMenu)
  const liveEsportsMenu = filterLiveMenu(esports, ESportItemMap)
  const { todayEsportsMenu, earlyEsportsMenu } = filterEsportNoLiveDropdownMenu(esports, liveEsportsMenu)

  return { liveMenu, todayMenu, earlyMenu, liveEsportsMenu, todayEsportsMenu, earlyEsportsMenu }
}

export const getHorseRacingMarkets = (marketTab) => {
  return (dispatch, getState) => {
    const sportId = getState().SidebarSelectedDataSlice.selectedSportId;
    const sport = getState().SidebarHandlerSlice.sports.filter(sport => {
      return sport[SportItemMap.id] === sportId
    })
    const {marketTabId, selectedMarketTab} = generateHRMarketId(sport[0], marketTab, SportItemMap);
    const markets = generateHorseRacingMarkets(sport[0] ? sport[0][marketTabId] : {}, SportItemMap);
    batch(() => {
      dispatch(changeHorseRacingMarketTab(selectedMarketTab));
      dispatch(updateMarkets(markets));
      const {selectedHorseRacingMarketId} = getState().SidebarSelectedDataSlice;
      if (!isNaN(selectedHorseRacingMarketId) && markets.length > 0) {
        const marketId = _.isEmpty(marketTab) ? BET_TYPE_HORSE_RACING.All : selectedHorseRacingMarketId;
        const selectedMarket = markets.filter(k => k.marketId === marketId);
        dispatch(changeHorseRacingMarketId(_.isEmpty(selectedMarket) ? markets[0].marketId : selectedMarket[0].marketId))
        dispatch(triggerOddsPage())
      }
    })
  }
}

export const generateHRMarketId = (sport, marketTab, sportMap) => {
  let marketTabId = _.isEmpty(marketTab) ? COMPACT_SPORT_MENU.nextThree : getMarketTabId(marketTab);
  let selectedMarketTab = !_.isEmpty(marketTab) ? marketTab : MARKET_TABS.NEXT_THREE;
  if(!marketTab && sport && sport[COMPACT_SPORT_MENU.nextThree]) {
    if(sport[COMPACT_SPORT_MENU.nextThree][sportMap.totalEvents] === 0 && sport[COMPACT_SPORT_MENU.todayMenu][sportMap.totalEvents] > 0) {
      marketTabId = COMPACT_SPORT_MENU.todayMenu;
      selectedMarketTab = MARKET_TABS.TODAY;
    } else if(sport[COMPACT_SPORT_MENU.nextThree][sportMap.totalEvents] === 0 && sport[COMPACT_SPORT_MENU.todayMenu][sportMap.totalEvents] === 0 && sport[COMPACT_SPORT_MENU.earlyMenu][sportMap.totalEvents] > 0) {
      marketTabId = COMPACT_SPORT_MENU.earlyMenu;
      selectedMarketTab = MARKET_TABS.EARLY;
    }
  }
  if(!marketTab && sport && _.isNil(sport[COMPACT_SPORT_MENU.nextThree])) {
    if(sport[COMPACT_SPORT_MENU.todayMenu] && sport[COMPACT_SPORT_MENU.todayMenu][sportMap.totalEvents] > 0) {
      marketTabId = COMPACT_SPORT_MENU.todayMenu;
      selectedMarketTab = MARKET_TABS.TODAY;
    } else if(sport[COMPACT_SPORT_MENU.earlyMenu] && sport[COMPACT_SPORT_MENU.earlyMenu][sportMap.totalEvents] > 0) {
      marketTabId = COMPACT_SPORT_MENU.earlyMenu;
      selectedMarketTab = MARKET_TABS.EARLY;
    }
  }
  return {marketTabId: marketTabId, selectedMarketTab: selectedMarketTab};
}

export const generateHorseRacingMarkets = (sport, sportMap) => {
  if (sport && sport[sportMap.horseRacingEvents] && sport[sportMap.horseRacingEvents].length > 0 && sport[sportMap.totalEvents] > 0) {
    return sport[sportMap.horseRacingEvents].reduce((markets, event, i) => {
      if(event > 0) {
        markets.push({
          marketId: Object.values(BET_TYPE_HORSE_RACING)[i],
          marketName: CommonUtil.getObjectKeyByValue(BET_TYPE_HORSE_RACING, i),
          numberEvents: event
        });
      }
      return markets;
    }, []);
  }
  return [];
}

export const getMarkets = (marketTab, isFromLanding = false) => {
  return (dispatch, getState) => {
    const sportTab = getState().SidebarSelectedDataSlice.selectedSportTab
    const previousSelectedSportTab = getState().SidebarSelectedDataSlice.previousSelectedSportTab
    if (sportTab === SPORT_TABS.VIRTUAL_SPORTS) {
      return
    }
    const sportId = getState().SidebarSelectedDataSlice.selectedSportId
    const isEsport = sportId === Constants.ESPORT_ID
    const esports = getState().SidebarHandlerSlice.esports
    const sports = getState().SidebarHandlerSlice.sports
    const { teasers } = getState().SidebarHandlerSlice
    const esportCode = getState().SidebarSelectedDataSlice.selectedEsportGame
    // Today tab is selected since Live tab is removed in WL skins
    const useTodayMarket = marketTab === MARKET_TABS.LIVE && window.env.hideLiveTabEnabled
    const isParlay = sportTab === SPORT_TABS.PARLAYS
    let markets = []
    let todayMarkets = []
    let tab = { marketTab: marketTab }
    let dataMarketParlay = {
      markets: [],
      marketTab: '',
      redirectToSportId: null
    } 
    
    if (!isEsport && sportTab === SPORT_TABS.SPORTS) {
      markets = getMarketsForSport(sports, tab, sportId, SportItemMap, teasers)
      todayMarkets = getMarketsForSport(sports, {marketTab: MARKET_TABS.TODAY}, sportId, SportItemMap, teasers)
    } else if (sportTab === SPORT_TABS.PARLAYS) { // enabled parlay tab only
      const props = {
        sports: isEsport ? esports : sports,
        tab: useTodayMarket ? {marketTab: MARKET_TABS.TODAY} : tab,
        sportId,
        teasers,
        isEsport,
        esportCode,
      };
      dataMarketParlay = getMarketForParlay(props) // => markets, tab, redirectToSportId
      markets = dataMarketParlay.markets
    } else if (isEsport || sportTab === SPORT_TABS.ESPORTS) {
      markets = getMarketsForEsport(esports, tab, esportCode)
      todayMarkets = getMarketsForEsport(esports, {marketTab: MARKET_TABS.TODAY}, esportCode)
    }  
    batch(() => {
      dispatch(changeMarketTab(useTodayMarket ? MARKET_TABS.TODAY : tab.marketTab))
      dispatch(updateMarkets(isParlay ? markets : useTodayMarket ? todayMarkets : markets))
      if (isFromLanding && markets.length > 0) {
        dispatch(changeMarketId(markets[0].marketId))
      } else if (isParlay) {
        if (dataMarketParlay.redirectToSportId) { // case the sport doesn't offer parlay
          if (previousSelectedSportTab === SPORT_TABS.SPORTS) {
            // previous sport tab is SPORTS => select today soccer parlay 
            const soccerMarkets = getMarketsForSport(sports, {marketTab: MARKET_TABS.TODAY}, Constants.SOCCER_ID, SportItemMap, teasers)
            dispatch(updateMarkets(soccerMarkets))
            dispatch(changeMarketId([BetTypeGroup.MIX_PARLAY, 0].join('|')))
            dispatch(changeSportId(Constants.SOCCER_ID))
            dispatch(changeMarketTab(MARKET_TABS.TODAY))
          } else {
            // select sports tab for selected sport
            dispatch(changeMarketId(dataMarketParlay.markets[0].marketId))
            dispatch(changeSportId(dataMarketParlay.redirectToSportId))
            dispatch(changeMarketTab(dataMarketParlay.marketTab))
            dispatch(changeSportTab(SPORT_TABS.SPORTS))
          }
        } else {
          dispatch(changeMarketId([BetTypeGroup.MIX_PARLAY, 0].join('|')))
          dispatch(changeMarketTab(dataMarketParlay.marketTab))
        }
        dispatch(triggerOddsPage())
      } else {
        // default market
        const selectedMarketId = getState().SidebarSelectedDataSlice.selectedMarketId
        if (!selectedMarketId && markets.length > 0) {
          const betTypeGroup = getState().SportsSlice.options.betTypeGroup
          const marketId = generateMarketId(betTypeGroup, 0)
          const selectedMarket = markets.filter(k => k.marketId === marketId)

          dispatch(changeMarketId(_.isEmpty(selectedMarket) ? markets[0].marketId : selectedMarket[0].marketId))
          dispatch(triggerOddsPage())
        }
      }
    })
  }
}

export const triggerOddsPage = () => {
  return (dispatch, getState) => {
      let options = {}, marketId;
      const { selectedMarketTab, selectedMarketId, selectedHorseRacingMarketId, selectedSportTab, selectedSportId, selectedEsportGame } = getState().SidebarSelectedDataSlice
      const optionsSportSlice = getState().SportsSlice.options
      options.isShowLiveTv = getState().SidebarHandlerSlice.isShowLiveTv
      const isHorseRacing = selectedSportId === Constants.HORSE_RACING_ID && selectedSportTab === SPORT_TABS.SPORTS;
      const betTypeGroup = isHorseRacing ? selectedHorseRacingMarketId : selectedMarketId.split('|')[0];
      const period = isHorseRacing ? selectedHorseRacingMarketId : selectedMarketId.split('|')[1] ;
      const isEsports = selectedSportId === Constants.ESPORT_ID || selectedSportTab === SPORT_TABS.ESPORTS;
      const { historyEsportLeagues } = getState().SelectLeaguesSlice;
      switch (selectedMarketTab) {
        case MARKET_TABS.LIVE:
          marketId = isEsports ? EsportMarket.Live : Market.Live
          break
        case MARKET_TABS.TODAY:
          marketId = isEsports ? EsportMarket.Soon : Market.Today
          break
        default:
          marketId = isEsports ? EsportMarket.PreGame : Market.Early
          break
      }
      
      if (isEsports) {
        options.sportId = Constants.ESPORT_ID;
        if (!getState().SportsSlice.options.favourite && !getState().SportsSlice.isSelectedHighlight) {
          const eSportGame = historyEsportLeagues.find(game => game.selectedEsportGame === selectedEsportGame);
          const selectedLeagues = eSportGame && eSportGame.selectedLeagues ? eSportGame.selectedLeagues : [];
          let leaguesHistory = [];
          if (selectedLeagues && selectedLeagues.length > 0) {
            const findESportGame = selectedLeagues.find(league => league.selectedMarketId === selectedMarketId && league.selectedMarketTab === selectedMarketTab);
            leaguesHistory = findESportGame && findESportGame.leaguesHistory ? findESportGame.leaguesHistory : [];
          }
          options.leagueIds = leaguesHistory;
          options.eSports = {
            eSportCode: selectedEsportGame === Constants.ESPORT_ALL_GAMES_CODE ? '' : selectedEsportGame,
            eSportLeagueIds: leaguesHistory
          }
        }
      } else {
        options.sportId = selectedSportId
        options.eSports = {}
      }

      options.market = marketId
      options.betTypeGroup = betTypeGroup
      if(!isHorseRacing) {
        options.period = period
      }
      let mode;
      let outrightType;
    
      switch (Number(betTypeGroup)) {
        case BetTypeGroup.MIX_PARLAY:
          mode = Mode.PARLAY_MARKET;
          break;
        case BetTypeGroup.CORRECT_SCORE:
          outrightType = OUTRIGHT_TYPE.CORRECT_SCORE;
          mode = Mode.OUTRIGHT_MARKET;
          break;
        case BetTypeGroup.SPECIALS:
          outrightType = OUTRIGHT_TYPE.SPECIAL;
          mode = Mode.OUTRIGHT_MARKET;
          break;
        case BetTypeGroup.OUTRIGHT:
          outrightType = OUTRIGHT_TYPE.OUTRIGHT;
          mode = Mode.OUTRIGHT_MARKET;
          break;
        case BetTypeGroup.DOUBLE_CHANCE:
          outrightType = OUTRIGHT_TYPE.DOUBLE_CHANCE;
          mode = Mode.OUTRIGHT_MARKET;
          break;
        case BetTypeGroup.TEASERS:
          options.teaser = {
            sportId: selectedSportId
          }
          mode = Mode.TEASER_MARKET;
          break;
        default:
          mode = Mode.NORMAL;
          break
      }
      if(optionsSportSlice && optionsSportSlice.mode !== Mode.LC && optionsSportSlice.mode !== Mode.TV && optionsSportSlice.mode !== Mode.ST) {
        options.mode = mode;
      }

      if(isHorseRacing && (optionsSportSlice.mode === Mode.LC || optionsSportSlice.mode === Mode.TV || optionsSportSlice.mode === Mode.ST)) {
        options.mode = mode;
      }
      
      if (outrightType) {
        options.outright = {
          sportId: selectedSportId,
          outrightType: outrightType
        }
      }
      if(getState().SportsSlice.search.isFirstLoading && window.location.pathname.lastIndexOf('/search') > -1){
        options.mode = Mode.SEARCH; 
        options.sportId = 0; 
        options.betTypeGroup = BetTypeGroup.HDP_OU;
        dispatch(changeSportId(0));
      }

      // prevent override sportId if odds page LC/LT received post message before left menu render
      if (optionsSportSlice.mode === Mode.LC || optionsSportSlice.mode === Mode.TV) {
        options.sportId = !isNaN(optionsSportSlice.sportId) ? optionsSportSlice.sportId : options.sportId;
      }

      dispatch(SportsSlice.actions.updateOptions(options));
  }

}

const getMarketsForSport = (sports, tab, sportId, sportMap, teasers) => {
  const sport = sports.filter(sport => {
    return sport[sportMap.id] === sportId
  })
  let marketTabId = COMPACT_SPORT_MENU.todayMenu
  // choose default market tab
  if (!tab.marketTab && sport.length > 0) {
    if (sport[0] && sport[0][marketTabId] && (sport[0][marketTabId][sportMap.totalEvents] + sport[0][marketTabId][sportMap.outrightEvents] === 0)) {
      marketTabId = COMPACT_SPORT_MENU.earlyMenu
    }
    tab.marketTab = marketTabId === COMPACT_SPORT_MENU.todayMenu ? MARKET_TABS.TODAY : MARKET_TABS.EARLY
  } else {
    marketTabId = getMarketTabId(tab.marketTab);
  }  
  return generateMarkets(sport[0] ? sport[0][marketTabId] : {}, sportMap, tab.marketTab === MARKET_TABS.EARLY  ? teasers : {})
}

const getMarketForParlay = (props) => {
  const {sports, tab, sportId, teasers, isEsport, esportCode} = props;
  const { TODAY, EARLY } = MARKET_TABS;
  const { todayMenu, earlyMenu } = COMPACT_SPORT_MENU;
  const secondMarketTabId = tab.marketTab === TODAY || !tab.marketTab ? earlyMenu : todayMenu;
  const originMarketTabId = tab.marketTab === TODAY || !tab.marketTab ? todayMenu : earlyMenu;
  const itemMap = isEsport ? ESportItemMap : SportItemMap;

  if (isEsport && esportCode === Constants.ESPORT_ALL_GAMES_CODE) {
    return {
      markets: generateMarketForAllEsportGames(sports, !tab.marketTab ? todayMenu : getMarketTabId(tab.marketTab)),
      marketTab: tab.marketTab,
      redirectToSportId: false
    }
  }

  const sport = sports.find(sport => [esportCode, sportId].includes(sport[itemMap.id]));
  const selectedMarketTabId = sport[originMarketTabId][itemMap.parlayEvents] > 0 ? originMarketTabId : secondMarketTabId;
  const selectedMarketTab = selectedMarketTabId === todayMenu ? TODAY : EARLY;
  
  const market = sport[selectedMarketTabId];
  const teaserMarket = isEsport || selectedMarketTab !== EARLY ? EMPTY_OBJECT : teasers;

  if (market[itemMap.parlayEvents] > 0) {
    return {
      markets: generateMarkets(market, itemMap, teaserMarket),
      marketTab: selectedMarketTab,
      redirectToSportId: false
    }
  } else {
    // There are no available parlay events => sports tab 
    const isTodayMarketHasEvent = generateMarkets(sport[todayMenu], itemMap, teaserMarket).length > 0
    const selectedMarketTabDefault = isTodayMarketHasEvent ? TODAY : EARLY;
    const marketDefault = isTodayMarketHasEvent ? sport[todayMenu] : sport[earlyMenu];
    return {
      markets: generateMarkets(marketDefault, itemMap, teaserMarket),
      marketTab: selectedMarketTabDefault,
      redirectToSportId: isEsport ? E_SPORT_ID : marketDefault[itemMap.id]
    } 
  }
};

const getMarketsForEsport = (esports, tab, esportCode) => {
  let markets = [], marketTabId
  if (esportCode === Constants.ESPORT_ALL_GAMES_CODE) {
    // default market tab for 'All Games' (Esports)
    marketTabId = COMPACT_SPORT_MENU.todayMenu
    if (!tab.marketTab) {
      tab.marketTab = MARKET_TABS.TODAY
    } else {
      // choose default market tab for other game esports
      marketTabId = getMarketTabId(tab.marketTab);
    }
    markets = generateMarketForAllEsportGames(esports, marketTabId)
  } else {
    const teasers = EMPTY_OBJECT
    markets = getMarketsForSport(esports, tab, esportCode, ESportItemMap, teasers)
  }
  return markets
}

const filterLiveMenu = (sports, sportMap) => {
  return sports.reduce((liveSports, sport) => {
    if (sport[COMPACT_SPORT_MENU.liveMenu][sportMap.running]) {
      let tmp = {}
      tmp.sportId = sportMap === SportItemMap ? sport[COMPACT_SPORT_MENU.liveMenu][sportMap.id] : sport[COMPACT_SPORT_MENU.liveMenu][sportMap.code]
      tmp.sportName = sport[COMPACT_SPORT_MENU.liveMenu][sportMap.name]
      tmp.totalEvents = sport[COMPACT_SPORT_MENU.liveMenu][sportMap.liveEvents]
      liveSports.push(tmp)
    }
    return liveSports
  }, [])
}

const filterNoLiveMenu = (sports, esports, selectedSportId) => {
  return sports.reduce((noLiveSports, sport) => {
    const tmp = {}
    const todaySports = sport[COMPACT_SPORT_MENU.todayMenu]
    const earlySports = sport[COMPACT_SPORT_MENU.earlyMenu]
    tmp.sportId = todaySports[SportItemMap.id]
    tmp.sportName = todaySports[SportItemMap.name]
    if (tmp.sportId === Constants.ESPORT_ID) {
      tmp.totalEvents = sumAllEventsEsport(esports)
    } else {
      tmp.totalEvents = sumEvents(todaySports, SportItemMap) + sumEvents(earlySports, SportItemMap)
    }
    noLiveSports.push(tmp)
    // click on esports in sport tabs
    /***** PINB-26648 ****** /
    /** if (tmp.sportId === Constants.ESPORT_ID && selectedSportId === Constants.ESPORT_ID) {
      const esportsMenu = filterEsportNoLiveMenu(esports);
      noLiveSports = noLiveSports.concat(esportsMenu)
    } **/
    return noLiveSports
  }, [])
}

const filterNoLiveDropdownMenu = (sports, esports, liveMenu) => {
  let todayMenu = []
  const earlyMenu = []

  sports.forEach(sport => {
    let numberOfTodayEvents = []
    let numberOfEarlyEvents = []
    const todaySports = sport[COMPACT_SPORT_MENU.todayMenu]
    const earlySports = sport[COMPACT_SPORT_MENU.earlyMenu]
    const sportId = todaySports[SportItemMap.id]
    const sportName = todaySports[SportItemMap.name]
    const isNotExistLiveEvents = liveMenu.findIndex(item => item.sportId === sportId) === -1

    if (sportId === Constants.ESPORT_ID) {
      const data = sumEventsEsportDropdown(esports)
      numberOfTodayEvents = data.numberOfSoonEvents
      numberOfEarlyEvents = data.numberOfPreGameEvents
    } else {
      numberOfTodayEvents = sumEvents(todaySports, SportItemMap) 
      numberOfEarlyEvents = sumEvents(earlySports, SportItemMap)
    }

    numberOfTodayEvents && isNotExistLiveEvents && todayMenu.push({sportId, sportName, totalEvents: numberOfTodayEvents})
    numberOfEarlyEvents && earlyMenu.push({sportId, sportName, totalEvents: numberOfEarlyEvents})
  })

  return { todayMenu, earlyMenu }
}

const filterEsportNoLiveMenu = (esports) => {
  return esports.reduce((noLiveSports, sport) => {
    const tmp = {}
    const todaySports = sport[COMPACT_SPORT_MENU.todayMenu]
    const earlySports = sport[COMPACT_SPORT_MENU.earlyMenu]
    tmp.sportId = todaySports[ESportItemMap.code]
    tmp.sportName = todaySports[ESportItemMap.name]
    tmp.totalEvents = sumEvents(todaySports, ESportItemMap) + sumEvents(earlySports, ESportItemMap)
    noLiveSports.push(tmp)
    return noLiveSports
  }, [
    {
      sportId: Constants.ESPORT_ALL_GAMES_CODE,
      sportName: 'All Games',
      totalEvents: sumAllEventsEsport(esports)}
  ])
}

const filterEsportNoLiveDropdownMenu = (esports, liveMenu) => {
  const todayEsportsMenu = []
  const earlyEsportsMenu = []
  let totalTodayEvents = 0
  let totalEarlyEvents = 0
  const allGames = {
    sportId: Constants.ESPORT_ALL_GAMES_CODE,
    sportName: 'All Games'
  }

  esports.forEach(sport => {
    const soonSports = sport[COMPACT_SPORT_MENU.todayMenu]
    const pregameSports = sport[COMPACT_SPORT_MENU.earlyMenu]
    const sportId = soonSports[ESportItemMap.code]
    const sportName = soonSports[ESportItemMap.name]
    const isNotExistLiveEvents = liveMenu.findIndex(item => item.sportId === sportId) === -1

    const numberOfTodayEvents = sumEvents(soonSports, ESportItemMap) 
    const numberOfEarlyEvents = sumEvents(pregameSports, ESportItemMap)

    totalTodayEvents += numberOfTodayEvents
    totalEarlyEvents += numberOfEarlyEvents

    numberOfTodayEvents && isNotExistLiveEvents && todayEsportsMenu.push({sportId, sportName, totalEvents: numberOfTodayEvents})
    numberOfEarlyEvents && earlyEsportsMenu.push({sportId, sportName, totalEvents: numberOfEarlyEvents}) 
  })

  totalTodayEvents && todayEsportsMenu.unshift({...allGames, totalEvents: totalTodayEvents})
  totalEarlyEvents && earlyEsportsMenu.unshift({...allGames, totalEvents: totalEarlyEvents})

  return { todayEsportsMenu, earlyEsportsMenu }
}

const generateVirtualSportsMenu = (sports) => {
  let vsMenu = []
  vsMenu.push({
    sportId: Constants.SOCCER_ID,
    sportCode: VirtualSports.VIRTUAL_SOCCER_WORLD_CUP.code,
    sportName: VirtualSports.VIRTUAL_SOCCER_WORLD_CUP.name,
    totalEvents: sports && sports.sp ? sports.sp[VirtualSports.VIRTUAL_SOCCER_WORLD_CUP.id] : 0
  })

  vsMenu.push({
    sportId: Constants.SOCCER_ID,
    sportCode: VirtualSports.VIRTUAL_SOCCER_NATIONS_CUP.code,
    sportName: VirtualSports.VIRTUAL_SOCCER_NATIONS_CUP.name,
    totalEvents: sports && sports.sp ? sports.sp[VirtualSports.VIRTUAL_SOCCER_NATIONS_CUP.id] : 0
  })

  vsMenu.push({
    sportId: Constants.BASKETBALL_ID,
    sportCode: VirtualSports.VIRTUAL_BASKETBALL.code,
    sportName: VirtualSports.VIRTUAL_BASKETBALL.name,
    totalEvents: sports && sports.sp ? sports.sp[VirtualSports.VIRTUAL_BASKETBALL.id] : 0
  })

  vsMenu.push({
    sportId: Constants.SOCCER_ID,
    sportCode: VirtualSports.VIRTUAL_SOCCER_LEAGUE.code,
    sportName: VirtualSports.VIRTUAL_SOCCER_LEAGUE.name,
    totalEvents: sports && sports.sp ? sports.sp[VirtualSports.VIRTUAL_SOCCER_LEAGUE.id] : 0
  })

  vsMenu.push({
    sportId: Constants.TENNIS_ID,
    sportCode: VirtualSports.VIRTUAL_TENNIS.code,
    sportName: VirtualSports.VIRTUAL_TENNIS.name,
    totalEvents: sports && sports.sp ? sports.sp[VirtualSports.VIRTUAL_TENNIS.id] : 0
  })

  vsMenu.push({
    sportId: Constants.VIRTUAL_HORSES_ID,
    sportCode: VirtualSports.VIRTUAL_HORSES.code,
    sportName: VirtualSports.VIRTUAL_HORSES.name,
    totalEvents: sports && sports.sp ? sports.sp[VirtualSports.VIRTUAL_HORSES.id] : 0
  })

  vsMenu.push({
    sportId: Constants.VIRTUAL_DOGS_ID,
    sportCode: VirtualSports.VIRTUAL_DOGS.code,
    sportName: VirtualSports.VIRTUAL_DOGS.name,
    totalEvents: sports && sports.sp ? sports.sp[VirtualSports.VIRTUAL_DOGS.id] : 0
  })
  return vsMenu
}

export const generateMarkets = (sport, sportMap, teasers) => {
  let markets = [], tmp = {}, defaultPeriod = 0
  const isHideTennisML = sport[sportMap.id] === Constants.TENNIS_ID && window.env.isHideTennisMLMarket
  // BetTypeSummary
  if (sport[sportMap.betTypeSummary] && sport[sportMap.betTypeSummary].length > 0) {
    for(let betType of sport[sportMap.betTypeSummary]) {
      tmp = {}
      tmp.marketId = generateMarketId(BetTypeGroup[betType[BetTypeSummaryMap.group]], 0)
      tmp.marketName = buildBetTypeTranslationKey(sport[sportMap.group], betType[BetTypeSummaryMap.group])  //group name
      tmp.numberEvents = betType[BetTypeSummaryMap.totalEvents]
      if(!(BetTypeGroup[betType[BetTypeSummaryMap.group]] === BetTypeGroup.ML_1X2 && isHideTennisML)){
        markets.push(tmp)
      }
    }
  }

  // Parlay
  if (sport[sportMap.parlayEvents] > 0) {
    tmp = {}
    tmp.marketId = generateMarketId(BetTypeGroup.MIX_PARLAY, defaultPeriod)
    tmp.marketName = Constants.MARKET_NAME.PARLAY
    tmp.numberEvents = sport[sportMap.parlayEvents]
    markets.push(tmp)
  }

  // Teaser
  if (teasers[sport[sportMap.id]]) {
    tmp = {}
    tmp.marketId = generateMarketId(BetTypeGroup.TEASERS, defaultPeriod)
    tmp.marketName = Constants.MARKET_NAME.TEASERS
    tmp.numberEvents = teasers[sport[sportMap.id]]['t']
    markets.push(tmp)
  }
  
  // Outright
  if (sport[sportMap.outrightEvents] > 0) {
    tmp = {}
    tmp.marketId = generateMarketId(BetTypeGroup.OUTRIGHT, defaultPeriod)
    tmp.marketName = Constants.MARKET_NAME.OUTRIGHT
    tmp.numberEvents = sport[sportMap.outrightEvents]
    markets.push(tmp)
  }
  // Correct Score
  if (sport[sportMap.correctScoreEvents] > 0) {
    tmp = {}
    tmp.marketId = generateMarketId(BetTypeGroup.CORRECT_SCORE, defaultPeriod)
    tmp.marketName = Constants.MARKET_NAME.CORRECT_SCORE
    tmp.numberEvents = sport[sportMap.correctScoreEvents]
    markets.push(tmp)
  }
  // Specials
  if (sport[sportMap.specialEvents] > 0) {
    tmp = {}
    tmp.marketId = generateMarketId(BetTypeGroup.SPECIALS, 0)
    tmp.marketName = Constants.MARKET_NAME.SPECIALS
    tmp.numberEvents = sport[sportMap.specialEvents]
    markets.push(tmp)
  }
  // Double Chance
  if (sportMap.doubleChanceEvents && sport[sportMap.doubleChanceEvents] > 0) {
    tmp = {}
    tmp.marketId = generateMarketId(BetTypeGroup.DOUBLE_CHANCE, 0)
    tmp.marketName = Constants.MARKET_NAME.DOUBLE_CHANCE
    tmp.numberEvents = sport[sportMap.doubleChanceEvents]
    markets.push(tmp)
  }
  
  // List of direct periods that having events
  if (sport[sportMap.directPeriodsFolders] && sport[sportMap.directPeriodsFolders].length > 1) {
    let index = 0
    for (let period of sport[sportMap.directPeriodsFolders]) {
      if (index > 0) {
        tmp = {}
        tmp.marketId = generateMarketId(BetTypeGroup.HDP_OU, period[DIRECT_PERIODS_FOLDER_SUM.periodNumber])
        tmp.marketName = period[DIRECT_PERIODS_FOLDER_SUM.periodNumber]
        tmp.numberEvents = period[DIRECT_PERIODS_FOLDER_SUM.totalEvents]
        markets.push(tmp)
      }
      index++
    }
  }
  return markets
}

const sumEvents = (sport, map) => {
  return sport[map.totalEvents] + sport[map.outrightEvents];
}

const sumAllEventsEsport = (esports) => {
  return esports.reduce((totalEvents, sport) => {
    const soonGames = sport[COMPACT_SPORT_MENU.todayMenu]
    const preGames = sport[COMPACT_SPORT_MENU.earlyMenu]
    return totalEvents + sumEvents(soonGames, ESportItemMap) +  sumEvents(preGames, ESportItemMap)
  }, 0)
}

const sumEventsEsportDropdown = (esports) => {
  let numberOfSoonEvents = 0
  let numberOfPreGameEvents = 0
  esports.forEach(sport => {
    const soonGames = sport[COMPACT_SPORT_MENU.todayMenu]
    const preGames = sport[COMPACT_SPORT_MENU.earlyMenu]
    numberOfSoonEvents += sumEvents(soonGames, ESportItemMap)
    numberOfPreGameEvents += sumEvents(preGames, ESportItemMap)
  })

  return { numberOfSoonEvents, numberOfPreGameEvents }
}

const getMarketTabId = (marketTab) => {
  let marketTabId;
  switch (marketTab) {
    case MARKET_TABS.LIVE:
      marketTabId = COMPACT_SPORT_MENU.liveMenu
      break
    case MARKET_TABS.TODAY:
    marketTabId = COMPACT_SPORT_MENU.todayMenu
      break
    case MARKET_TABS.NEXT_THREE:
      marketTabId = COMPACT_SPORT_MENU.nextThree;
      break;
    default:
      marketTabId = COMPACT_SPORT_MENU.earlyMenu
      break
  }
  return marketTabId;
}

const generateMarketForAllEsportGames = (esports, marketTabId) => {
  let allMarkets = [], betTypeMarkets = [], directPeriodsFoldersMarkets = [], specificMarkets = []

  // get all esport by market tab
  esports = esports.map(sport => {
    return sport[marketTabId]
  })
  for (let sport of esports) {
    // BetTypeSummary
    if (sport[ESportItemMap.betTypeSummary].length > 0) {
      for(let betType of sport[ESportItemMap.betTypeSummary]) {
        const marketId = generateMarketId(BetTypeGroup[betType[BetTypeSummaryMap.group]], 0)
        groupEventsForAllGamesMarket(betTypeMarkets, marketId, buildBetTypeTranslationKey(sport[ESportItemMap.group], betType[BetTypeSummaryMap.group]), betType[BetTypeSummaryMap.totalEvents])
      }
    }
    // Parlay
    groupEventsForAllGamesMarket(specificMarkets, generateMarketId(BetTypeGroup.MIX_PARLAY, 0), Constants.MARKET_NAME.PARLAY, sport[ESportItemMap.parlayEvents])
    // Outright
    groupEventsForAllGamesMarket(specificMarkets, generateMarketId(BetTypeGroup.OUTRIGHT, 0), Constants.MARKET_NAME.OUTRIGHT, sport[ESportItemMap.outrightEvents])
    // Correct Score
    groupEventsForAllGamesMarket(specificMarkets, generateMarketId(BetTypeGroup.CORRECT_SCORE, 0), Constants.MARKET_NAME.CORRECT_SCORE, sport[ESportItemMap.correctScoreEvents])
    // Specials
    groupEventsForAllGamesMarket(specificMarkets, generateMarketId(BetTypeGroup.SPECIALS, 0), Constants.MARKET_NAME.SPECIALS, sport[ESportItemMap.specialEvents])
    
    // List of direct periods that having events
    if (sport[ESportItemMap.directPeriodsFolders] && sport[ESportItemMap.directPeriodsFolders].length > 1) {
      let index = 0
      for (let period of sport[ESportItemMap.directPeriodsFolders]) {
        if (index > 0) {
          const marketId = generateMarketId(BetTypeGroup.HDP_OU, period[DIRECT_PERIODS_FOLDER_SUM.periodNumber])
          groupEventsForAllGamesMarket(directPeriodsFoldersMarkets, marketId, buildPeriodTranslationKey(Constants.ESPORT_ID, period[DIRECT_PERIODS_FOLDER_SUM.periodNumber]), period[DIRECT_PERIODS_FOLDER_SUM.totalEvents])
        }
        index++
      }
    }
  }
  directPeriodsFoldersMarkets.sort((a, b) => a.marketId.localeCompare(b.marketId))
  allMarkets = betTypeMarkets.concat(specificMarkets).concat(directPeriodsFoldersMarkets)
  return allMarkets.filter(market => {
    return market.numberEvents > 0
  });
}

const groupEventsForAllGamesMarket = (markets, marketId, marketName, totalEvent) => {
  const existingMarket = markets.filter(market => {
    return market.marketName === marketName
  })
  if (existingMarket.length === 0) {
    markets.push({
      marketId: marketId,
      marketName: marketName,
      numberEvents: totalEvent
    })
  } else {
    existingMarket[0].numberEvents = existingMarket[0].numberEvents + totalEvent 
  }
  return markets
}

const buildBetTypeTranslationKey = (betTypeGroupId, betTypeGroupName) => {
  return CommonUtil.getObjectKeyByValue(SportGroup, betTypeGroupId).toLowerCase() + ':' + betTypeGroupName
}


const buildPeriodTranslationKey = (sportId, periodNumber) => {
  return 'periods:'+['periods', sportId, periodNumber].join('_');
}

export const generateMarketId = (betTypeGroup, period) => {
  return [betTypeGroup, period].join('|');
}

export const updateSportId = (sportId, sportTab, marketTab, isHighLight) => {
  return (dispatch, getState) => {
    let isEsportGameCode = false
    dispatch(SportsSlice.actions.updateIsSelectedHighlight(isHighLight));
    if (!isHighLight || (isHighLight && sportId !== Constants.ESPORT_ID )) {
      dispatch(changeSportTab(sportTab))
    }
    // re-render all sports on left menu if switching between normal sports and esports
    if ([SPORT_TABS.SPORTS, SPORT_TABS.PARLAYS].includes(sportTab)) {
      if (!isNaN(sportId)) {
        batch(() => {
          if (getState().SidebarSelectedDataSlice.selectedSportId === Constants.ESPORT_ID || sportId === Constants.ESPORT_ID) {
            dispatch(changeEsportGame(Constants.ESPORT_ALL_GAMES_CODE))
          }
          dispatch(enableReUpdateNoLiveMenu()) // re-render sport menu if switching between sports and esports
          dispatch(changeSportId(sportId))
          if (getState().SidebarSelectedDataSlice.isReUpdateNoLiveMenu) {
            dispatch(getMenuBySportTab(marketTab))
            if (sportId !== Constants.ESPORT_ID) {
              dispatch(disableReUpdateNoLiveMenu()) // if switching sports after selecting esport
            }
          }
        })
        
      } else {
        isEsportGameCode = true
      }
    } if (sportTab === SPORT_TABS.VIRTUAL_SPORTS && !isHighLight) {
      batch(() => {
        dispatch(changeVirtualSportId(sportId));
        const options = {
          mode: Mode.VS_NORMAL,
          virtualSports: {
            sportId: sportId
          }
        };
        dispatch(SportsSlice.actions.updateChangedOptions(options))
        dispatch(changeVSBetslipTab(BETSLIP_TABS.SINGLE))
      })
    }
    batch(() => {
      if (isEsportGameCode || sportTab === SPORT_TABS.ESPORTS) {
        if (isHighLight){
            dispatch(changeSportId(sportId))
            const eSportCode = _.get(getState().SportsSlice.options, 'eSports.eSportCode', '');
            dispatch(changeEsportGame(eSportCode));
        } else {
          dispatch(changeEsportGame(sportId)) // click on game in esport menu
        }
      }
      if(sportId !== Constants.HORSE_RACING_ID){
        if (marketTab) {
          dispatch(getMarkets(marketTab))
        } else {
          dispatch(getMarkets())
        }
      } else {
        const currentHRTab = getState().SidebarSelectedDataSlice.selectedHorseRacingMarketTab;
        dispatch(getHorseRacingMarkets(currentHRTab))
      }
    })
    
  }
}

export const switchSportTab = (tabId) => {
  return (dispatch, getState) => {
    const { isSelectEsportLiveTab, selectedSportTab, selectedMarketTab, isSelectFromDropdown } = getState().SidebarSelectedDataSlice
    const { isSelectedHighlight } = getState().SportsSlice
    const mode = getState().SportsSlice.options.mode;
    const isSelectParlay = tabId === SPORT_TABS.PARLAYS;
    const isSelectEsportWhileInParlay = tabId === SPORT_TABS.ESPORTS && selectedSportTab === SPORT_TABS.PARLAYS;
    if (selectedSportTab === tabId || mode === Mode.SEARCH) {
      return
    }
    dispatch(resetNormalMode());
    const {
      sports
    } = getState().SidebarHandlerSlice
    batch(() => {
      if (tabId === SPORT_TABS.SPORTS && sports.length > 0 && !isSelectedHighlight && !isSelectFromDropdown) {
        // Reset to default sport id when redirect from esport page
        dispatch(changeSportId(sports[0][0] === Constants.ESPORT_ID ? sports[1][0] : sports[0][0]));
        dispatch(SportsSlice.actions.updateOptions({betTypeGroup: sports[0][0] === Constants.HORSE_RACING_ID ? BET_TYPE_HORSE_RACING.All : BetTypeGroup.HDP_OU}));
      }
      if (tabId === SPORT_TABS.ESPORTS && window.env.leftMenuRemoveEsportsTab) {
        dispatch(changeSportId(Constants.ESPORT_ID));
      } else if (tabId === SPORT_TABS.VIRTUAL_SPORTS) {
          const sportName = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1).toLowerCase();
          const defaultVsSportId = URL_VS_SPORTS_CODE.includes(sportName) ? sportName.split('-')[1] : VirtualSports.VIRTUAL_SOCCER_LEAGUE.code
          dispatch(changeVirtualSportId(defaultVsSportId))
          dispatch(updateChangedOptions({
            mode: Mode.VS_NORMAL,
            virtualSports: {
              sportId: defaultVsSportId
            }
          }))
      } else {
        !isSelectedHighlight && dispatch(updateChangedOptions({
          leagueIds: []
        }))
      }

      if(!isSelectFromDropdown) {
        if (isSelectEsportLiveTab) {
          dispatch(changeMarketTab(MARKET_TABS.LIVE))
          dispatch(updateSelectEsportLiveTab(false))
        } else if(!isSelectParlay) {
          dispatch(resetMarketTab())
        }
      }
      isSelectFromDropdown && dispatch(setIsSelectFromDropdown(false))

      if (isSelectParlay || isSelectEsportWhileInParlay) {
        // Keep market tab and select parlay market after switch to parlay
        dispatch(changeMarketId([BetTypeGroup.MIX_PARLAY, 0].join('|')))
        dispatch(changeMarketTab(selectedMarketTab))
      } else {
        dispatch(resetEsportGame())
        dispatch(resetMarketId())
      }

      if (isSelectEsportWhileInParlay) {
        dispatch(changeSportTab(SPORT_TABS.PARLAYS))
      } else {
        dispatch(changeSportTab(tabId))
      }
      dispatch((getMenuBySportTab()))
    })
    
    }
  }
const resetNormalMode = () => {
  return (dispatch, getState) => {
    const mode = _.get(getState().SportsSlice, 'options.mode', 0);
    switch (mode) {
      case Mode.SEARCH:
        dispatch(resetSearchData())
        break;
      case Mode.LC:
        dispatch(resetLiveCenter())
        break;
      case Mode.TV:
        dispatch(resetLiveTV())
        break;
      default:
        break;
    }
  }
}
const updateHasLiveEvent = (numOfLiveTVEvents) => {
  return (dispatch, getState) => {
    const { isBlockedLiveStreaming } = getState().AccountsSlice.user;
    if (!_.isNil(numOfLiveTVEvents) && !isBlockedLiveStreaming) {
      const hasEvent = numOfLiveTVEvents > 0;
      dispatch(LayoutTemplateSlice.actions.updateHasLiveTV(hasEvent));
      dispatch(SportsSlice.actions.updateOptions({ hasLiveTVEvent: hasEvent }));
    }
  }
}

const udpateLeftMenuByIndex = (isEsport, sport) => {
  return (dispatch, getState) => {
    if (isEsport) {
      batch(() => {
        dispatch(updateLeftMenu({ key: "esports", data: sport }));
        dispatch(getMenuBySportTab())
      })
      return;
    }
    let sports = JSON.parse(JSON.stringify(getState().SidebarHandlerSlice.sports))
    const indexUpdatedSport = sports.findIndex(cloneSport => cloneSport[0] === sport[SportItemMap.id])
    if (indexUpdatedSport > -1) { // handle for update existed sport
      const todaySports = sport[COMPACT_SPORT_MENU.todayMenu]
      const earlySports = sport[COMPACT_SPORT_MENU.earlyMenu]
      const totalNonLiveEvent = sumEvents(todaySports, SportItemMap) + sumEvents(earlySports, SportItemMap)
      if ((!todaySports.length && !earlySports.length) || !totalNonLiveEvent) { //remove sport if total nolive event = 0
        sports.splice(indexUpdatedSport, 1);
      } else {
        sports[indexUpdatedSport] = sport
      }
    } else { // handle for add sport
      sports.push(sport)
      sports = CommonUtil.sortSportsPriority(sports, getState().SportsSlice.options.sportsSorting)
    }
    batch(() => {
      dispatch(updateLeftMenu({ key: "sports", data: sports }));
      dispatch(getMenuBySportTab())
    })
  }
}

export const onReceiveLeftMenuWebSocketMessage = (updatedSport) => {
  return (dispatch, getState) => {
    const { leftMenu, esport, type } = updatedSport;
    if (_.isNil(leftMenu)) return;
    switch (type) {
      case MESSAGES_LEFT_MENU_WS.FULL_LEFT_MENU:
        dispatch(onGetSportMarket(leftMenu));
        break;
      case MESSAGES_LEFT_MENU_WS.UPDATE_LEFT_MENU:
        dispatch(udpateLeftMenuByIndex(esport, leftMenu));
        break;
      case MESSAGES_LEFT_MENU_WS.UPDATE_GROUPS_OUTRIGHT:
        break;
      case MESSAGES_LEFT_MENU_WS.UPDATE_GROUPS_TEASER:
        const teaserGroup = leftMenu.m.reduce((teasers, sport) => {
          teasers[sport.i] = sport
          return teasers;
        }, {})
        dispatch(updateLeftMenu({ key: "teasers", data: teaserGroup }));
        break;
      case MESSAGES_LEFT_MENU_WS.UPDATE_SPECIAL_LEAGUES:
        dispatch(updateLeftMenu({ key: "specialLeagues", data: leftMenu }));
        break;
      case MESSAGES_LEFT_MENU_WS.UPDATE_NUM_LIVE_TV:
        dispatch(updateHasLiveEvent(leftMenu));
        break;
      default:
        break;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/slices/SidebarHandlerSlice.js